import { render, staticRenderFns } from "./createServiceModal.vue?vue&type=template&id=6ddc57c8&scoped=true"
import script from "./createServiceModal.vue?vue&type=script&lang=js"
export * from "./createServiceModal.vue?vue&type=script&lang=js"
import style0 from "./createServiceModal.vue?vue&type=style&index=0&id=6ddc57c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddc57c8",
  null
  
)

export default component.exports